import { ContentCopy as CopyIcon, Done as DoneIcon } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import { useState } from "react";
import { Typography } from "@mui/material";
import { Button } from "@/components/core";

/**
 * @param {{
 * [label]: String
 * copy: String
 * }} - text to copy
 */
export function CopyButton({ label, copy, color = "inherit" }: any) {
  const { t } = useTranslation("common");
  const [isCopied, setIsCopied] = useState(false);

  return (
    <Button
      onClick={() => {
        navigator.clipboard.writeText(copy);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }}
      color={color}
      startIcon={isCopied ? <DoneIcon color={color} /> : <CopyIcon color={color} />}
    >
      <Typography color={color}>{isCopied ? t("copied") : label || t("copy")}</Typography>
    </Button>
  );
}

CopyButton.propTypes = {
  label: PropTypes.string,
  copy: PropTypes.string.isRequired,
  color: PropTypes.string,
};
